import { Nullable } from 'types';
import type { Funnelable, LocationInfo } from '../types';
import { Funnel } from '../types';
import type { LegalLocations } from './legal';

export default class LegalLocationsImpl implements LegalLocations, Funnelable {
  imprint: LocationInfo = {
    pathname: '/imprint',
    funnels: [],
  };

  termsOfUse: LocationInfo = {
    pathname: '/terms',
    funnels: [],
  };

  licenseAgreement: LocationInfo = {
    pathname: '/license',
    funnels: [],
  };

  funnelsForPathname(pathname: string): Nullable<Funnel[]> {
    const { imprint, termsOfUse, licenseAgreement } = this;
    if (pathname === imprint.pathname) return imprint.funnels;
    if (pathname === termsOfUse.pathname) return termsOfUse.funnels;
    if (pathname === licenseAgreement.pathname) return licenseAgreement.funnels;
    return null;
  }
}
